import { Paper, Toolbar, Typography } from '@material-ui/core';
import React from 'react';
import Layout from '../../../common/components/Layout';
import ReturnButton from '../../../common/components/ReturnButton';
import { SimpleBreadcrumbs } from '../../../common/components/SimpleBreadcrumbs';
import { getProject } from '../../../common/services/project';
import { BroadcastAffiliationForm, IBroadcastAffiliationPayload } from '../components/BroadcastAffiliationForm.component';
import { IComponentProps } from './AddBroadcastAffiliation.connector';

export class AddBroadcastAffiliation extends React.Component<IComponentProps> {
  public render() {
    const {
      intl: { messages: m },
    } = this.props;

    return (
      <Layout
        id="broadcast-affiliation-add-layout"
        top={
          <SimpleBreadcrumbs
            crumbStack={[
              {
                labelKey: 'app_broadcastAffiliations',
                href: `#${getProject().url}/broadcast-affiliations`,
              },
            ]}
          />
        }
        main={
          <Paper elevation={2}>
            <Toolbar>
              <Typography variant="h6">{m.app_broadcastAffiliationAdd}</Typography>
              <div style={{ flex: 1 }} />
              <ReturnButton entity="broadcast-affiliations" />
            </Toolbar>
            <BroadcastAffiliationForm onSubmit={this.handleSubmit} />
          </Paper>
        }
      />
    );
  }

  private handleSubmit = (payload: IBroadcastAffiliationPayload) => {
    const { addBroadcastAffiliation, history } = this.props;

    // @ts-ignore - thunk returns a promise resolving to the dispatched action
    addBroadcastAffiliation({ locale: getProject().lang, ...payload }).then(({ payload: created }) => {
      if (created && created.id) {
        history.push(`${getProject().url}/broadcast-affiliations/${created.id}`);
      }
    });
  };
}
